import { reduce } from "lodash";
import { create } from "zustand";

import { Song } from "../types/song.types";

interface IgnoredSongStore {
  songs: object;
  setSongs: (songs: Song[]) => void;
  setIgnoreToSong: (songId: string) => void;
  removeIgnoreFromSong: (songId: string) => void;
}

const ignoredSongStore = create<IgnoredSongStore>((set) => ({
  songs: new Set<Song>(),

  setSongs: (songs: Song[]) => {
    const objectToStore = reduce(
      songs,
      (acc, song) => ({
        ...acc,
        [song.id]: true,
      }),
      {}
    );
    set({ songs: objectToStore });
  },

  setIgnoreToSong: (songId: string) => {
    set((state) => {
      const status = !state.songs[songId];
      const updatedObject = { ...state.songs, [songId]: status };
      return { songs: updatedObject };
    });
  },

  removeIgnoreFromSong: (songId: string) => {
    set((state) => {
      const updatedObject = { ...state.songs, [songId]: false };
      return { songs: updatedObject };
    });
  },
}));

export default ignoredSongStore;
